import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';

/**
 * CONSULTATION & AUDIT PAGE
 * Theme: 60% Aqua Haze, 30% River Bed, 10% Cerulean Blue
 * Branding: Authority Headline Style (#020617)
 */
const ConsultationAudit = () => {
  return (
    <div className="min-h-screen bg-[#F0F4F8] text-[#4A5568] font-sans">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-24 bg-white border-b border-[#F0F4F8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter text-[#020617] uppercase">
            Consultation <span className="text-[#2B6CB0]">& Audit</span>
          </h1>
          <p className="text-xl text-[#4A5568] max-w-3xl mx-auto mb-10 leading-relaxed font-medium">
            Strategic digital guidance tailored for the businesses that build our community. 
            We turn complex data into actionable roadmaps for growth.
          </p>
          <Link to="/contact" className="inline-block bg-[#2B6CB0] text-white px-10 py-4 rounded-xl font-black uppercase tracking-widest text-sm hover:bg-[#020617] transition-all shadow-lg shadow-[#2B6CB0]/20">
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Detailed Content */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-32">
            <div>
              <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tighter text-[#020617] uppercase leading-none">
                Strategic Digital <br/> Consulting
              </h2>
              <p className="text-lg text-[#4A5568] mb-6 leading-relaxed font-medium">
                Our audit services provide deep insights into how your business connects with local and global audiences.
              </p>
              <p className="text-lg text-[#4A5568]/80 mb-8 font-medium">
                From main street cafes to large-scale enterprises, we provide the technical roadmap and creative strategy needed to lead your industry.
              </p>
              <div className="w-20 h-2 bg-[#2B6CB0]"></div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800"
                alt="Strategic Planning"
                className="w-full h-[450px] object-cover rounded-2xl shadow-2xl border-8 border-white grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>
          </div>

          {/* Industries Grid */}
          <div className="mb-32">
            <h2 className="text-3xl md:text-5xl font-black text-center mb-16 tracking-tighter text-[#020617] uppercase">
              Sectors We <span className="text-[#2B6CB0]">Elevate</span>
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { title: 'Small Business & Retail', desc: 'Transforming local shops into high-traffic digital storefronts for our neighbors.' },
                { title: 'Hospitality & Dining', desc: 'Digital menus and booking systems that capture the unique flavor of local cafes.' },
                { title: 'Emerging Entrepreneurs', desc: 'Fast-tracking local startups with professional identities and conversion-ready sites.' },
                { title: 'Enterprise & Big Business', desc: 'Secure, scalable infrastructure for our region’s largest employers and industry leaders.' },
                { title: 'Professional Services', desc: 'Building authority for local consultants and firms through trust-first design.' },
                { title: 'Community & Impact', desc: 'Amplifying the mission of local nonprofits with accessible, purpose-driven hubs.' }
              ].map((industry) => (
                <div key={industry.title} className="bg-white p-10 rounded-2xl border border-[#F0F4F8] shadow-sm hover:border-[#2B6CB0]/30 transition-all group">
                  <h3 className="text-sm font-black mb-4 text-[#020617] uppercase tracking-widest flex items-center gap-3">
                    <span className="w-2 h-2 bg-[#2B6CB0] rounded-full group-hover:scale-150 transition-transform"></span>
                    {industry.title}
                  </h3>
                  <p className="text-[#4A5568] text-sm leading-relaxed font-medium">{industry.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA Card */}
          <div className="text-center bg-[#020617] p-16 rounded-[3rem] shadow-2xl relative overflow-hidden">
            {/* Background design element */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#2B6CB0] opacity-10 rounded-full -mr-32 -mt-32"></div>
            
            <h2 className="text-4xl md:text-6xl font-black mb-8 tracking-tighter text-white uppercase">
              Need Expert <span className="text-[#2B6CB0]">Guidance?</span>
            </h2>
            <p className="text-xl text-white/70 mb-10 max-w-2xl mx-auto font-medium">
              Let's discuss your challenges and develop a strategic plan to achieve your digital goals.
            </p>
            <div className="flex flex-wrap gap-4 justify-center relative z-10">
              <Link to="/contact" className="bg-[#2B6CB0] text-white px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs hover:bg-white hover:text-[#020617] transition-all">
                Schedule Consultation
              </Link>
              <Link to="/services" className="border-2 border-white/20 text-white px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs hover:bg-white hover:text-[#020617] transition-all">
                View All Services
              </Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default ConsultationAudit;